/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import Button from "components/Button";
import AddIcon from "@material-ui/icons/Add";
import Select from "components/Select";
import DeleteIcon from "@material-ui/icons/Delete";
import TextField from "components/TextField";
import AmericanBusinessLogo from "assets/images/american-business.jpeg";
import {
  imsRetailOrderUpdateOrder,
  cancelOrder,
  americanBusinessOrderEvents,
  americanBusinessArtFiles,
} from "actions/orders";
import {
  Row,
  SubRow,
  RowHeader,
  RowFooter,
  PrintAreaWrapper,
  PrintAreaTitle,
  PrintAreaRow,
  Colorway,
  AddButton,
} from "styles/pages/smart-print-sink";

const regExpr = /[^a-zA-Z0-9- ]/g;

const OrbitkitModal = ({ onClose, open, data }) => {
  const dispatch = useDispatch();
  const [events, setEvents] = useState(null);
  const [artFiles, setArtFiles] = useState();
  const [lineItems, setLineItems] = useState();

  useEffect(() => {
    (async () => {
      if (data?.order_data?.ponumber[0] && !events) {
        const response = await dispatch(
          americanBusinessOrderEvents({
            orderNumber: data?.order_data?.ponumber[0],
          })
        );

        setEvents(response);
      }
    })();
  }, [data?.order_data?.ponumber[0], dispatch]);

  useEffect(() => {
    const itemDetail =
      data?.order_data?.manifests[0]?.integrationmanifest[0]?.lineitems[0]
        .integrationlineitem;

    if (!!itemDetail && !lineItems && !!artFiles?.length) {
      setLineItems(
        itemDetail.map((p) => {
          return {
            ...p,
            printAreas: [
              {
                printArea:
                  p?.designs[0]?.integrationdesign[0]?.integrationcolorway[0]
                    ?.garmentlocationname[0],
                printAreaArtFile: `${p?.designs[0]?.integrationdesign[0]?.designcode[0]}-${p?.designs[0]?.integrationdesign[0]?.integrationcolorway[0]?.colorwayid[0]}`,
              },
            ],
          };
        })
      );
    }
  }, [data, lineItems, artFiles]);

  useEffect(() => {
    if (!artFiles) {
      (async () => {
        const response = await dispatch(americanBusinessArtFiles());
        setArtFiles(
          response?.map((r) => ({
            ...r,
            value: `${r?.designNumber}-${r?.colorwayNumber}`,
          }))
        );
      })();
    }
  }, [artFiles]);

  const shipToAddress =
    data?.order_data?.manifests[0]?.integrationmanifest[0]?.shiptoaddress[0];

  const shippingCountry = shipToAddress?.country[0];

  const address1 = shipToAddress?.address1 ? shipToAddress?.address1[0] : "";
  const city = shipToAddress?.city[0];
  const state = shipToAddress?.state[0];
  const zip = shipToAddress?.zip[0];
  const firstName = shipToAddress?.name
    ? shipToAddress?.name[0]
    : shipToAddress?.address1
    ? shipToAddress?.address1[0]
    : "";

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle style={{ paddingBottom: 0 }}>
        <CloseIcon
          style={{ float: "right", cursor: "pointer", color: "#a1a1a1" }}
          onClick={onClose}
        />
      </DialogTitle>
      <DialogContent style={{ paddingTop: 0 }}>
        {!!lineItems &&
          lineItems.map((d, index) => {
            const orderLineItem = d;

            const sku =
              orderLineItem?.integrationproduct[0]?.customerproductname[0].replace(
                regExpr,
                ""
              );

            const description =
              orderLineItem?.integrationproduct[0]?.description[0];

            const size = description?.split("/")[1];

            const color = orderLineItem?.integrationproduct[0]?.color[0];

            const designCode =
              orderLineItem?.designs[0]?.integrationdesign[0]?.designcode[0];

            const colorWayId =
              orderLineItem?.designs[0]?.integrationdesign[0]
                ?.integrationcolorway[0]?.colorwayid[0];

            const garmentLocationName =
              orderLineItem?.designs[0]?.integrationdesign[0]
                ?.integrationcolorway[0]?.garmentlocationname[0];

            const quantity =
              orderLineItem?.lineitemsizes[0]?.integrationlineitemsize[0]
                ?.quantity[0];

            return (
              <Row key={index}>
                <RowHeader>
                  <span>SKU:{sku}</span>
                  <span>Size:{size}</span>
                  <span>Color:{color}</span>
                  <span>Quantity:{quantity}</span>
                </RowHeader>

                <RowHeader>{description}</RowHeader>

                <RowHeader>
                  <span>Desgin Code:{designCode}</span>
                  <span>Colorway id:{colorWayId}</span>
                  <span>Garment Location Name:{garmentLocationName}</span>
                </RowHeader>

                <SubRow>
                  <img src={AmericanBusinessLogo} alt="thumb" />
                </SubRow>

                <PrintAreaWrapper>
                  <PrintAreaTitle>Print Areas</PrintAreaTitle>
                  <AddButton>
                    <AddIcon
                      onClick={() => {
                        setLineItems(
                          lineItems?.map((l, j) => {
                            if (j !== index) return l;
                            return {
                              ...l,
                              printAreas: [
                                ...orderLineItem.printAreas,
                                { printAreaName: "", selectedArtFile: "" },
                              ],
                            };
                          })
                        );
                      }}
                    />
                  </AddButton>
                </PrintAreaWrapper>

                {!!artFiles?.length &&
                  orderLineItem?.printAreas?.map((o, z) => (
                    <PrintAreaRow key={`printArea${z}`}>
                      <TextField
                        size="small"
                        placeholder="Print Area"
                        value={o?.printArea || ""}
                        onChange={(v) => {
                          setLineItems(
                            lineItems?.map((l, j) => {
                              if (j !== index) return l;
                              return {
                                ...l,
                                printAreas: l?.printAreas?.map((t, y) => {
                                  if (z !== y) return t;
                                  return { ...t, printArea: v };
                                }),
                              };
                            })
                          );
                        }}
                      />

                      <Colorway>
                        <Select
                          label="Select Design#-Colorway#"
                          valueKey="value"
                          options={artFiles}
                          defaultValue=""
                          value={{ value: o?.printAreaArtFile || "" }}
                          onChange={(v) => {
                            setLineItems(
                              lineItems?.map((l, j) => {
                                if (j !== index) return l;
                                return {
                                  ...l,
                                  printAreas: l?.printAreas?.map((t, y) => {
                                    if (z !== y) return t;
                                    return { ...t, printAreaArtFile: v };
                                  }),
                                };
                              })
                            );
                          }}
                        />
                        {!!o?.printAreaArtFile && (
                          <div className="src">
                            <img
                              width="50"
                              height="30"
                              alt="thumb"
                              src={
                                artFiles?.find(
                                  (a) => a?.value === o?.printAreaArtFile
                                )?.artUrls?.png ||
                                artFiles
                                  ?.find(
                                    (a) => a?.value === o?.printAreaArtFile
                                  )
                                  ?.artUrls?.pdf?.replace(".pdf", ".png")
                              }
                            />
                          </div>
                        )}
                      </Colorway>

                      {z > 0 && (
                        <DeleteIcon
                          onClick={() => {
                            setLineItems(
                              lineItems?.map((l, j) => {
                                if (j !== index) return l;
                                return {
                                  ...l,
                                  printAreas: [
                                    ...l?.printAreas.slice(0, z),
                                    ...l?.printAreas.slice(
                                      z + 1,
                                      l?.printAreas.length
                                    ),
                                  ],
                                };
                              })
                            );
                          }}
                        />
                      )}
                    </PrintAreaRow>
                  ))}
              </Row>
            );
          })}

        <RowHeader>
          {firstName}
          &nbsp;
          <br />
          {address1}
          <br />
          {city}&nbsp;
          {state}&nbsp;
          {shippingCountry}&nbsp;
          {zip}
        </RowHeader>

        <Stepper alternativeLabel activeStep={events?.length}>
          {events?.map((e, index) => (
            <Step key={`${index}_keys`}>
              <StepLabel>
                {e?.action?.toUpperCase()}
                <br />
                {moment(e?.time).format("MMM DD,YYYY")}
                <br />
                {e?.tracking?.trackingNumber || ""}
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        <RowFooter style={{ display: "none" }}>
          {data?.Status !== "Declined" && data?.Status !== "Shipped" && (
            <Button
              className="declined"
              title="Decline"
              onClick={async () => {
                const payload = {
                  OrderNumber: data?.cart?.header[0]?.sessionid[0],
                  Status: "Declined",
                  Event: {
                    action: "declined",
                    time: moment().format("YYYY-MM-DD"),
                  },
                };
                await dispatch(imsRetailOrderUpdateOrder(payload));
                await dispatch(
                  cancelOrder({
                    printProvider: "US",
                    source: "Admin",
                    orderId: `FICO-${data?.cart?.header[0]?.sessionid[0]}`,
                  })
                );
                onClose();
              }}
            />
          )}
          {data?.Status !== "Approved" &&
            data?.Status !== "Processed" &&
            data?.Status !== "Shipped" && (
              <Button
                title="Approve"
                className="approve"
                disabled={
                  !!lineItems?.find((o) =>
                    o?.printAreas?.find(
                      (p) => !p?.printArea || !p?.printAreaArtFile
                    )
                  )
                }
                onClick={async () => {
                  // const payload = {
                  //   OrderNumber: data?.cart?.header[0]?.sessionid[0],
                  //   Status: 'Approved',
                  //   Event: {
                  //     action: 'approved',
                  //     time: moment().format('YYYY-MM-DD'),
                  //   },
                  // };
                  // await dispatch(imsRetailOrderUpdateOrder(payload));

                  // await dispatch(
                  //   imsRetailOrderUpdateOrder({
                  //     OrderNumber: data?.cart?.header[0]?.sessionid[0],
                  //     Status: 'Processed',
                  //     Event: {
                  //       action: 'processed',
                  //       time: moment().format('YYYY-MM-DD'),
                  //     },
                  //   })
                  // );

                  const orderId = data?.order_data?.ponumber[0];

                  let items = "";

                  for (let i = 0; i < lineItems?.length; i++) {
                    const orderLineItem = lineItems[i];

                    const sku =
                      orderLineItem?.integrationproduct[0]?.customerproductname[0].replace(
                        regExpr,
                        ""
                      );

                    const description =
                      orderLineItem?.integrationproduct[0]?.description[0];

                    // const size = description?.split("/")[1];
                    const size =
                      orderLineItem?.lineitemsizes[0]
                        ?.integrationlineitemsize[0]?.size[0];

                    const color =
                      orderLineItem?.integrationproduct[0]?.color[0];

                    const garmentLocationName =
                      orderLineItem?.designs[0]?.integrationdesign[0]
                        ?.integrationcolorway[0]?.garmentlocationname[0];

                    const quantity =
                      orderLineItem?.lineitemsizes[0]
                        ?.integrationlineitemsize[0]?.quantity[0];

                    items += `<Item>
                    <SKU>[EMB] ${sku}</SKU>
                    <Descrip>${description}</Descrip>
                    <Color>${color}</Color>
                    <Qty>${Number(quantity)}</Qty>
                    <Size>${size}</Size>
                    <Type>EMB</Type>
                    <Style>${sku}</Style>
                    <ProcessMode>Piece</ProcessMode>`;

                    for (let f = 0; f < orderLineItem?.printAreas.length; f++) {
                      const p = orderLineItem?.printAreas[f];
                      items += `<Design>
                      <Location>${p?.printArea?.split("\n")}</Location>
                      <Thumb>${
                        artFiles?.find((a) => a?.value === p?.printAreaArtFile)
                          ?.artUrls?.png ||
                        artFiles
                          ?.find((a) => a?.value === p?.printAreaArtFile)
                          ?.artUrls?.pdf?.replace(".pdf", ".png")
                      }</Thumb>
                      <SourceFile>${
                        artFiles?.find((a) => a?.value === p?.printAreaArtFile)
                          ?.artUrls?.dst
                      }</SourceFile>
                      <WhiteUnderbaseRequired>false</WhiteUnderbaseRequired>
                    </Design>`;
                    }

                    // <Design>
                    //   <Location>${garmentLocationName || 'FRONT'}</Location>
                    //   <Thumb>https://attachments.office.net/owa/narinder%40bigoventees.com/service.svc/s/GetAttachmentThumbnail?id=AAMkADcxYjkyYjIyLTYwODEtNGE4Yi1iOTNmLTgzNWVmNWQ2NDliNwBGAAAAAAASoxfWqhh%2BRpA%2Bf%2F9r%2BNHQBwDYIoGCL4AvS6eRXnfyzKjYAAAAAAEJAADYIoGCL4AvS6eRXnfyzKjYAAK2bAS%2BAAABEgAQAC6RualZpgxBjcinAHlSwl0%3D&thumbnailType=2&token=eyJhbGciOiJSUzI1NiIsImtpZCI6IkZBRDY1NDI2MkM2QUYyOTYxQUExRThDQUI3OEZGMUIyNzBFNzA3RTkiLCJ0eXAiOiJKV1QiLCJ4NXQiOiItdFpVSml4cThwWWFvZWpLdDRfeHNuRG5CLWsifQ.eyJvcmlnaW4iOiJodHRwczovL291dGxvb2sub2ZmaWNlLmNvbSIsInVjIjoiMmRkN2Q2NGEwYTllNDg0ODhkNTQ4YzhmMGUzNGQ1ZjYiLCJzaWduaW5fc3RhdGUiOiJbXCJrbXNpXCJdIiwidmVyIjoiRXhjaGFuZ2UuQ2FsbGJhY2suVjEiLCJhcHBjdHhzZW5kZXIiOiJPd2FEb3dubG9hZEAwMzk2OGMwZi00MjgzLTQ5ODAtOGQwYi02OTU2MDBjOTM5M2IiLCJpc3NyaW5nIjoiV1ciLCJhcHBjdHgiOiJ7XCJtc2V4Y2hwcm90XCI6XCJvd2FcIixcInB1aWRcIjpcIjExNTM4MDExMTUyOTQzMTkwNTlcIixcInNjb3BlXCI6XCJPd2FEb3dubG9hZFwiLFwib2lkXCI6XCJiOGYxMWJlZS0wNGE2LTQ0MTAtYTNlMi01ODY4YjcyNTQ1NGJcIixcInByaW1hcnlzaWRcIjpcIlMtMS01LTIxLTM5NzE5NTY3OC0xOTY5Njg2MjMxLTIyMjY0NjU5MC0xNDQ4NjUyOFwifSIsIm5iZiI6MTY1NTIxNDE2MywiZXhwIjoxNjU1MjE0NzYzLCJpc3MiOiIwMDAwMDAwMi0wMDAwLTBmZjEtY2UwMC0wMDAwMDAwMDAwMDBAMDM5NjhjMGYtNDI4My00OTgwLThkMGItNjk1NjAwYzkzOTNiIiwiYXVkIjoiMDAwMDAwMDItMDAwMC0wZmYxLWNlMDAtMDAwMDAwMDAwMDAwL2F0dGFjaG1lbnRzLm9mZmljZS5uZXRAMDM5NjhjMGYtNDI4My00OTgwLThkMGItNjk1NjAwYzkzOTNiIiwiaGFwcCI6Im93YSJ9.rayZT3QMxXAxcWH68U0ARXZMDWl-MvlTYxZHxwwYD0yDya7Q4nV8URenOVV9fI6TEQNax1d-n-G6B0TFWLTBjvB0e8Ob_ZUN_WGoHxky-ik9JlA0N4JjCwlaxGfaM2zSElWv1SeC3Eg5jqCFQfNjFfhxu1uMHIMUu7z_qS-jBZorbiI_4WZew4KaiUj-h38ipMgMqNQKbWmAxYvbHEW3z-r_yvm1c5BuAG2CBug3QqZbGPDHYBD_-yB4M_tdKLiXkM5B_Gexk58nBgqFv_8Z8dx65agAucCZz82hHxddBefIjAXF02lnmmoLUFl4z7I__LoZgiQ9HOIW96gCIcGv2Q&X-OWA-CANARY=lxR5BWt7T0myziXB74QHnhCjpdkLTtoYCtm322FYTdp5K0qtsjvXG_-RR7U117RqruDDLcUgm-g.&owa=outlook.office.com&scriptVer=20220603005.06&animation=true</Thumb>
                    //   <SourceFile>https://attachments.office.net/owa/narinder%40bigoventees.com/service.svc/s/GetAttachmentThumbnail?id=AAMkADcxYjkyYjIyLTYwODEtNGE4Yi1iOTNmLTgzNWVmNWQ2NDliNwBGAAAAAAASoxfWqhh%2BRpA%2Bf%2F9r%2BNHQBwDYIoGCL4AvS6eRXnfyzKjYAAAAAAEJAADYIoGCL4AvS6eRXnfyzKjYAAK2bAS%2BAAABEgAQAC6RualZpgxBjcinAHlSwl0%3D&thumbnailType=2&token=eyJhbGciOiJSUzI1NiIsImtpZCI6IkZBRDY1NDI2MkM2QUYyOTYxQUExRThDQUI3OEZGMUIyNzBFNzA3RTkiLCJ0eXAiOiJKV1QiLCJ4NXQiOiItdFpVSml4cThwWWFvZWpLdDRfeHNuRG5CLWsifQ.eyJvcmlnaW4iOiJodHRwczovL291dGxvb2sub2ZmaWNlLmNvbSIsInVjIjoiMmRkN2Q2NGEwYTllNDg0ODhkNTQ4YzhmMGUzNGQ1ZjYiLCJzaWduaW5fc3RhdGUiOiJbXCJrbXNpXCJdIiwidmVyIjoiRXhjaGFuZ2UuQ2FsbGJhY2suVjEiLCJhcHBjdHhzZW5kZXIiOiJPd2FEb3dubG9hZEAwMzk2OGMwZi00MjgzLTQ5ODAtOGQwYi02OTU2MDBjOTM5M2IiLCJpc3NyaW5nIjoiV1ciLCJhcHBjdHgiOiJ7XCJtc2V4Y2hwcm90XCI6XCJvd2FcIixcInB1aWRcIjpcIjExNTM4MDExMTUyOTQzMTkwNTlcIixcInNjb3BlXCI6XCJPd2FEb3dubG9hZFwiLFwib2lkXCI6XCJiOGYxMWJlZS0wNGE2LTQ0MTAtYTNlMi01ODY4YjcyNTQ1NGJcIixcInByaW1hcnlzaWRcIjpcIlMtMS01LTIxLTM5NzE5NTY3OC0xOTY5Njg2MjMxLTIyMjY0NjU5MC0xNDQ4NjUyOFwifSIsIm5iZiI6MTY1NTIxNDE2MywiZXhwIjoxNjU1MjE0NzYzLCJpc3MiOiIwMDAwMDAwMi0wMDAwLTBmZjEtY2UwMC0wMDAwMDAwMDAwMDBAMDM5NjhjMGYtNDI4My00OTgwLThkMGItNjk1NjAwYzkzOTNiIiwiYXVkIjoiMDAwMDAwMDItMDAwMC0wZmYxLWNlMDAtMDAwMDAwMDAwMDAwL2F0dGFjaG1lbnRzLm9mZmljZS5uZXRAMDM5NjhjMGYtNDI4My00OTgwLThkMGItNjk1NjAwYzkzOTNiIiwiaGFwcCI6Im93YSJ9.rayZT3QMxXAxcWH68U0ARXZMDWl-MvlTYxZHxwwYD0yDya7Q4nV8URenOVV9fI6TEQNax1d-n-G6B0TFWLTBjvB0e8Ob_ZUN_WGoHxky-ik9JlA0N4JjCwlaxGfaM2zSElWv1SeC3Eg5jqCFQfNjFfhxu1uMHIMUu7z_qS-jBZorbiI_4WZew4KaiUj-h38ipMgMqNQKbWmAxYvbHEW3z-r_yvm1c5BuAG2CBug3QqZbGPDHYBD_-yB4M_tdKLiXkM5B_Gexk58nBgqFv_8Z8dx65agAucCZz82hHxddBefIjAXF02lnmmoLUFl4z7I__LoZgiQ9HOIW96gCIcGv2Q&X-OWA-CANARY=lxR5BWt7T0myziXB74QHnhCjpdkLTtoYCtm322FYTdp5K0qtsjvXG_-RR7U117RqruDDLcUgm-g.&owa=outlook.office.com&scriptVer=20220603005.06&animation=true</SourceFile>
                    //   <WhiteUnderbaseRequired>false</WhiteUnderbaseRequired>
                    // </Design>

                    items += `</Item>`;
                  }

                  const xml = `<AddXml xmlns="http://tempuri.org/">
                    <OrderString>
                    <Request>
                        <CustID>1</CustID>
                        <PO>AB-${orderId}</PO>
                        
                        <Source>Admin</Source>
                        <Store>Big Oven Tees</Store>
                        <StoreID>1</StoreID>
                        <ShipTo>
                            <FirstName>${firstName}</FirstName>
                            <LastName></LastName>
                            <Company></Company>
                            <Adrx1>${address1}</Adrx1>
                            <Adrx2></Adrx2>
                            <City>${city}</City>
                            <State>${state}</State>
                            <Zip>${zip}</Zip>
                            <Country>${shippingCountry}</Country>
                            <Email></Email>
                        </ShipTo>
                        <ShipFrom>
                            <FirstName>Big Oven Tees</FirstName>
                            <LastName></LastName>
                            <Company>Big Oven Tees USA</Company>
                            <Adrx1>8742 Buffalo Avenue</Adrx1>
                            <Adrx2></Adrx2>
                            <City>Niagara Falls</City>
                            <State>NY</State>
                            <Zip>14304</Zip>
                            <Country>US</Country>
                            <Email>info@bigoventees.com</Email>
                          </ShipFrom>
                        <ShipMethod>UPS By ShipStation [UPS Ground]</ShipMethod>          
                        <ProductionPriority>Normal</ProductionPriority>
                        <Notes>SAGE ORDER ${orderId}</Notes>
                        ${items}                        
                    </Request>
                </OrderString>
              </AddXml>`;

                  // await dispatch(submitOrderToUSA(xml, token));
                  // onClose();
                }}
              />
            )}
        </RowFooter>
      </DialogContent>
    </Dialog>
  );
};

export default OrbitkitModal;
